import * as React from "react";
import Svg, { Path } from "react-native-svg";

const HeartIcon = (props) => (
  <Svg
    width={14}
    height={15}
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M12.62 4.649a3.555 3.555 0 0 0-.779-1.132A3.628 3.628 0 0 0 9.293 2.48 3.651 3.651 0 0 0 7 3.287a3.651 3.651 0 0 0-2.293-.808A3.628 3.628 0 0 0 2.16 3.517a3.534 3.534 0 0 0-1.065 2.525c0 .455.093.93.277 1.412.155.403.376.822.66 1.244.448.669 1.064 1.366 1.83 2.073a20.467 20.467 0 0 0 2.578 2.014l.324.207a.44.44 0 0 0 .472 0l.324-.207a20.735 20.735 0 0 0 2.579-2.014c.765-.707 1.382-1.404 1.83-2.073.283-.422.506-.84.66-1.244.184-.483.277-.957.277-1.412a3.481 3.481 0 0 0-.286-1.393ZM7 11.91s-4.867-3.118-4.867-5.87c0-1.392 1.152-2.522 2.574-2.522 1 0 1.866.558 2.293 1.373a2.582 2.582 0 0 1 2.293-1.373c1.422 0 2.574 1.13 2.574 2.523 0 2.75-4.867 5.87-4.867 5.87Z"
      fill="#EC3535"
    />
  </Svg>
);

export default HeartIcon;
